import React from 'react';
import styled from 'styled-components';

import { AnimatedLoadingPlaceholder } from '../../../../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';

export const LocationTitleLoadingUI = () => {
    return (
        <Container>
            <AnimatedLoadingPlaceholder width={237} height='23px' />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;
`;
